module.exports = __webpack_public_path__ + "img/district.e3f468a6.svg";